import { scroll } from '../../mixins/index';
import fields from './fields/index';
export default {
    props: ['acf'],
    mixins: [ scroll ],
    components: {
        ... fields
    },
    mounted() {
      this.fields[`${this.getProduct()}Model`] = this.acf.model ? this.acf.model : 'this product'
      this.fields[`${this.getProduct()}Brand`] = this.acf.brand ? this.acf.brand : 'this product'
      //* If is a MACHINE OR MOBI have the device model and brand
      if(this.getProduct() === 'device'){
		    this.fields.businessSegment = this.acf.businessSegment ? this.acf.businessSegment : '';
      }
      // Get now date
      var date = new Date();
      this.fields.timeOnMachineDatestamp = date.toISOString().substring(0, 10);
      
      this.addOptGroup();
    },
    methods: {
        sendToMarketo(fields){
          var _self = this;
          let account = location.hostname === 'falcon-sbx-1.eba-g4cd8xpy.us-west-2.elasticbeanstalk.com' ? _self.acf.account.dev : _self.acf.account.prod;
          MktoForms2.loadForm("https://app-ab10.marketo.com", account, _self.acf.account.id, function(mktoForm){
            // on success event
            mktoForm.onSuccess(function(values, followUrl){
              // send the form data to php
                setTimeout(function(){
                  _self.sendProductReview(fields, account);
                }, 3000)
                // false to no refresh
                return false;
            });
          });
          MktoForms2.whenReady(function(mktoForm) {
            mktoForm.addHiddenFields(_self.getMarketoFields(fields));
            mktoForm.submit()
          })
      },
      getProduct(){
        //* If is a AIRMINI have the travel device model
        if(this.acf.travelDeviceModel != ''){
            return "travelDevice";
        //* If is a MASK have the mask model and brand
        }else if(typeof this.fields.maskModel === 'string'){
            return "mask";
        //* If is a MACHINE OR MOBI have the device model and brand
        }else if(typeof this.fields.deviceModel === 'string'){
            return "device";
        }
      },
      getMarketoFields(fields){
        let productCap = this.getProduct().charAt(0).toUpperCase() + this.getProduct().slice(1);
        let product = this.getProduct();
        let data = {
            FirstName: fields.firstname,
            LastName: fields.lastname,
            Email: fields.email,
            State: fields.state,
            Country: fields.country,
            marketingConsent: fields.marketing_consent,
            consumerJourneyPhase: fields.consumerJourneyPhase,
            consumerJourneyPhaseDetail: fields.consumerJourneyPhaseDetail,
            patientProvidedNoPurchaseReason: '',
            businessSegment: fields.businessSegment,
            b2C: fields.b2c,
            b2B: fields.b2b
        }
        if( fields.marketing_consent) {
          data.marketingConsentDate = fields.marketingConsentDate;
        }
		
		if(fields.yes_Rating) {
			if(product == 'mask'){
				data[`maskBrandProductRegistration`] = fields[`maskBrand`];
				data[`holdingMaskModel`] = fields[`maskModel`];
			}else if(product == 'device'){
				data[`deviceBrandProductRegistration`] = fields[`deviceBrand`];
				data[`holdingDeviceModel`] = fields[`deviceModel`];
			}else if(product == 'travelDevice') {	 	
				data[`holdingTravelDeviceModel`] = this.acf.travelDeviceModel; //ResMed Mobi or ResMed AirMini
			}
		}else{
			if(product == 'mask'){
				if(fields[`otherMaskBrand`]){
					data[`maskBrandProductRegistration`] = fields[`otherMaskBrand`];
					if(fields[`otherMaskBrand`] == 'Other'){
						// otherMaskModels = their text
						data[`otherMaskModels`] = fields[`otherMaskModels`];
					}else{
						// holdingMaskModel = their selection
						data[`holdingMaskModel`] = fields[`otherMaskModels`];
					}
				}
			}else if( product == 'device'){
				if(fields[`otherDeviceBrand`]){
					data[`deviceBrandProductRegistration`] = fields[`otherDeviceBrand`];
					if(fields[`otherDeviceBrand`] == 'Other'){
						// otherDeviceModels = their text entry
						data[`otherDeviceModels`] = fields[`otherDeviceModels`];
					}else{
						// holdingDeviceModel = their selection
						data[`holdingDeviceModel`] = fields[`otherDeviceModels`];
					}
				}
			}else if(product == 'travelDevice'){		
				// nothing to do here
			}
		}
        return data;
      },
      sendProductReview(fields, account){
        // on before send
        axios.interceptors.request.use((config) => {
            this.response.message = '';
            this.validation = {};
            return config;
        });
        let data = fields;
        if (!this.sendTimeOnMachineDatestamp || fields.userLength == '') {
            delete data.timeOnMachineDatestamp;
        }
        data.account = account;
        axios({
            method: 'post',
            url: '/wp-content/themes/resmed/src/js/components/forms/form-product-review-process.php',
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            data: data
        }).then((response) => {
            let data = response.data;
            this.scroll({
                to: `.component-0b2c6199`,
                duration: 1200,
                callback: (() => { })
            });
            this.status.idle = null;
            this.status.complete = true;
        });
      },
      validateBaseInfo(){
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(this.fields.email).toLowerCase())) {
            this.validation.email = ['Please enter your email address in format: yourname@example.com']
            this.status.errors = true
        }
        if (!this.fields.country) {
            this.validation.country = ['This field is required']
            this.status.errors = true
        }
      },
      validateCustomInfo(){
        if (typeof this.fields.starRating !== 'undefined' && !this.fields.starRating) {
          this.validation.starRating = ['This field is required']
          this.status.errors = true
        }
        if (this.userLengthRequired == true && typeof this.fields.userLength !== 'undefined' && !this.fields.userLength) {
          this.validation.userLength = ['This field is required'];
          this.status.errors = true;
        }
        if (this.replacementFrequencyRequired == true && typeof this.fields.replacementFrequency !== 'undefined' && !this.fields.replacementFrequency) {
          this.validation.replacementFrequency = ['This field is required'];
          this.status.errors = true;
        }
        if (typeof this.fields.recommendProduct !== 'undefined' && !this.fields.recommendProduct) {
          this.validation.recommendProduct = ['Please select one option']
          this.status.errors = true
        }
        if (typeof this.fields.firstname !== 'undefined' && !this.fields.firstname.length) {
          this.validation.firstname = ['This field is required']
          this.status.errors = true
        }
        if (typeof this.fields.lastname !== 'undefined' && !this.fields.lastname.length) {
          this.validation.lastname = ['This field is required']
          this.status.errors = true
        }
        if (typeof this.fields.state !== 'undefined' && !this.fields.state) {
          this.validation.state = ['This field is required']
          this.status.errors = true
        }
        if (typeof this.fields.notPurchasedReason !== 'undefined' && !this.fields.notPurchasedReason) {
          this.validation.notPurchasedReason = ['This field is required']
          this.status.errors = true
        }
        if (typeof this.fields.fieldsclimateLineAir !== 'undefined' && !this.fields.climateLineAir) {
          this.validation.climateLineAir = ['Please select one option']
          this.status.errors = true
        }
      },
      addOptGroup() {
        //if (navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i)) {
        if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) ) {
          var selects = document.querySelectorAll("select");
          for (var i = 0; i < selects.length; i++ ){
              selects[i].appendChild(document.createElement("optgroup"));
          }
        }
      },
      
      reset() {
          this.status.step = 0;
          return this.fields = {
              ...fillable
          }
      },
      submit(event) {
          this.validation = {}
          this.validateBaseInfo()
          this.validateCustomInfo()
          if (this.status.errors) {
              this.status.errors = false
              return false;
          }else{
              this.status.idle = true;
              this.sendToMarketo(this.fields)
          }
      },
      created() {
          this.form.name = this.$parent.name;
          this.form.origin = this.$parent.origin;
          
      }
    }
}